import request from '@/utils/request'
import type {Switch, SwitchTypeEnum} from "@/type/system/Switch";
import type {AxiosPromise} from "axios";
import type {AjaxResponse} from "@/type/HTTP";

// 查询开关状态
export function getSwitchBySwitchType(switchType: SwitchTypeEnum, params: any): AxiosPromise<AjaxResponse<Switch>> {
    return request({
        url: `/switch/type/${switchType}`,
        method: 'get',
        params
    })
}

export function updateSwitch(data: Switch): AxiosPromise<AjaxResponse<any>> {
    return request({
        url: `/switch`,
        method: 'put',
        data
    })
}

export function addSwitch(data: Switch): AxiosPromise<AjaxResponse<any>> {
    return request({
        url: `/switch`,
        method: 'gepostt',
        data
    })
}
